import { io } from 'socket.io-client';

// Same-origin connection: works with CRA's dev proxy and the production build.
const socket = io();

export default socket;
